export const CheckIneligibility = (formState, isPartnerLoanProtection) => {

    const IneligibleNoDrivingReason = [
        "My license has been suspended or revoked",
        "I have a medical restriction to driving",
        "I am unable to physically appear at the license bureau",
    ];

    const IneligiblePersonalHistoryFields = [
        "extremeSports", "felony", "bannedCountries", "outsideUS180days",
        "suspendedDriversLicense", "dui5years"
    ];

    const IneligibleMedicalHistoryFields = [
        "illegalDrugUse", "illegalPrescriptionDrugUse",
        "aids", "incompleteFollowup", "alcoholOrDrugAbuse", "heartDisease", "stroke", "lungDisease", "depressionBipolar",
        "cognitiveDisorder", "muscularDystrophy", "kidneyLiverDisease", "leukemia", "arthritis",
        "sleepApnea"
    ];

    const IneligibleDiabetesFields = [
        "diabetesPriorToAge40", "insulinDependent", "complicationsfromDiabetes"
    ];

    const newFormState = formState && formState.steps;

    const checkInsuredIneligibility = () => {
        const gettingToKnowYou = newFormState.gettingToKnowYou;
        const identityVerification = newFormState.identityVerification;
        const isIneligible = gettingToKnowYou.ownerIsProposedInsured === 'false'
            || (gettingToKnowYou.proposedInsuredIsUSCitizen === 'false' && gettingToKnowYou.proposedInsuredIsPermanentResident === 'false')
            || identityVerification.employmentStatus !== 'Employed'
            || (identityVerification.validDriverLicense === 'false' && identityVerification.noDrivingReason && IneligibleNoDrivingReason.find(reason => reason === identityVerification.noDrivingReason));
        return isIneligible;
    };

    const checkPersonalMedicalIneligibility = () => {
        const personalHistory = newFormState.personalHistory;
        const medicalHistory = newFormState.medicalHistory;
        const hasFieldsOfPersonalHistory = IneligiblePersonalHistoryFields.some(prop => personalHistory[prop] === 'true');
        const hasFieldsOfMedicalHistory = IneligibleMedicalHistoryFields.some(prop => medicalHistory[prop] === 'true');
        const hasFieldsOfDiabetes = IneligibleDiabetesFields.some(prop => medicalHistory[prop] === 'true');

        const isIneligible = hasFieldsOfPersonalHistory
            || (personalHistory.movingViolations5Years === 'true' && personalHistory.numberofMovingViolations === '5 or more')
            || hasFieldsOfMedicalHistory
            || (medicalHistory.useRecreationalMarijuana === 'true' && medicalHistory.marijuanaFrequency === 'More than 3 times a week')
            || (medicalHistory.diabetes === 'true' && hasFieldsOfDiabetes);
        return isIneligible;
    };

    if (isPartnerLoanProtection ? formState.currentStep === 2 : formState.currentStep === 3) {
        return checkInsuredIneligibility();
    }
    else if (isPartnerLoanProtection ? formState.currentStep === 3 : formState.currentStep === 4) {
        return checkPersonalMedicalIneligibility();
    }
    return false;
};
